import React from "react";
import {connect} from "react-redux";

import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Table from "components/Table/Table.jsx";
import Checkbox from "components/Checkbox/Checkbox";
import Add from "@material-ui/icons/Add";
import Create from "@material-ui/icons/Create";
import Close from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import CheckboxCore from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";

import styles from "assets/jss/material-dashboard-pro-react/views/form";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import {
  ibSave,
  //ibsFetch,
  ibFetch
} from 'actions/ibs'

import {
  danger,
} from 'actions/notification'

class IbBankAccounts extends React.Component {
	state = {
		selected: -1,
		showForm: false,
		form:{
			//bankAccountId: -1,
			bankName: '',
			beneficiaryAccountName: '',
			defaultBankAccount: true,
			beneficiaryAccountNumber: '',
			beneficiaryAddress: '',
			beneficiaryIban: '',
			branchName: '',
			swiftCode: '',
			correspondentBankName: '',
			correspondentSwiftCode: ''
		},
		ib:{
			bankAccounts: []
		}
  }

	componentDidMount() {
		if(this.props.match.params.id) {
			this.props.saveWizardData(this.props.stepDataObject.data)
			this.setState({
				...this.state,
				ib: {
					bankAccounts: this.props.stepDataObject.data.bankAccounts
				}
			})
		}
	}

	setCheckboxValue(key){
		const {form} = this.state
		let keyItemValue = form[key]

		this.setState({
			...this.state,
			form: {
				...form,
				[key]: !keyItemValue
			}
		})
	}
	renderCheckbox(options){
		const {classes} = this.props
		const value = this.state.form[options.key]
		return(
			<div
				key={options.key}
				className={
					classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}
			>
				<FormControlLabel
					control={
						<CheckboxCore
							tabIndex={-1}
							onClick={() => this.setCheckboxValue(options.key)}
							checked={value}
							checkedIcon={
								<Check className={classes.checkedIcon} />
							}
							icon={<Check className={classes.uncheckedIcon} />}
							classes={{
								checked: classes.checked
							}}
						/>
					}
					classes={{
						label: classes.label
					}}
					label={options.label}
				/>
			</div>
		)
	}
	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: <small>(optional)</small>)}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
	}

	addNew(){
		this.setState({
			...this.state,
			showForm: true,
			form:{
				bankName: '',
				defaultBankAccount: true,
				beneficiaryAccountName: '',
				beneficiaryAccountNumber: '',
				beneficiaryAddress: '',
				beneficiaryIban: '',
				branchName: '',
				swiftCode: '',
				correspondentBankName: '',
				correspondentSwiftCode: ''
			}
		})
		
	}

	saveTableItem(e){
		e.preventDefault()
		const state = this.state
		let ib = this.state.ib
		const newItem = {
			bankName: this.state.form.bankName,
			beneficiaryAccountName: this.state.form.beneficiaryAccountName,
			beneficiaryAccountNumber:  this.state.form.beneficiaryAccountNumber,
			beneficiaryAddress: this.state.form.beneficiaryAddress,
			beneficiaryIban: this.state.form.beneficiaryIban,
			branchName: this.state.form.branchName,
			swiftCode: this.state.form.swiftCode,
			defaultBankAccount: this.state.form.defaultBankAccount,
			correspondentBankName: this.state.form.correspondentBankName,
			correspondentSwiftCode: this.state.form.correspondentSwiftCode
		}
		if(this.state.form.bankAccountId){
			newItem.bankAccountId = this.state.form.bankAccountId
			ib.bankAccounts = ib.bankAccounts.filter((x) => x.bankAccountId !== newItem.bankAccountId)
		}
		if(newItem.defaultBankAccount){
			//remove default from other nodes
			ib.bankAccounts = ib.bankAccounts.map((item) => {
				item.defaultBankAccount = false
				return item
			})
		}
		
		ib.bankAccounts.push(newItem)
		let data = {...this.props.wizardData, ...ib}
    this.props.save(data)
      .then(e => {
				this.props.fetch(e.ibId)
					.then((res) => {
						this.props.saveWizardData(e)
						this.setState({
							...state,
							ib:{
								bankAccounts: res.bankAccounts
							},
							showForm: false
						})

					})
        //this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})
	}
	closeForm(){
		this.setState({
			...this.state,
			showForm: false
		})
	}
	renderAddItemForm(){
		
		return(
			<form onSubmit={(e) => this.saveTableItem(e)}>
				<GridContainer justify="center">
					<GridItem xs={12} sm={11} md={11}>
						
						{this.getInput({
							key:'bankName',
							name:'Bank Name',
							icon:'',
							type:'text',
							required:true
						})}
						
						{this.getInput({
							key:'beneficiaryAccountName',
							name:'Beneficiary Account Name',
							icon:'',
							type:'text',
							required:true
						})}
						
						{this.getInput({
							key:'beneficiaryAccountNumber',
							name:'Beneficiary Account Number',
							icon:'',
							type:'text',
							required:true
						})}

						{this.getInput({
							key:'beneficiaryAddress',
							name:'Beneficiary Address',
							icon:'',
							type:'text',
							required:true
						})}

						{this.getInput({
							key:'branchName',
							name:'Branch Name',
							icon:'',
							type:'text',
							required:true
						})}

						{this.getInput({
							key:'beneficiaryIban',
							name:'Beneficiary Iban',
							icon:'',
							type:'text',
							required:true
						})}

						
						{this.getInput({
							key:'swiftCode',
							name:'Swift Code',
							icon:'',
							type:'text',
							required:true
						})}

						{this.getInput({
							key:'correspondentBankName',
							name:'Correspondent Bank Name',
							icon:'',
							type:'text',
							required:false
						})}

						{this.getInput({
							key:'correspondentSwiftCode',
							name:'Correspondent Swift Code',
							icon:'',
							type:'text',
							required:false
						})}
					</GridItem>
					<GridItem xs={12} sm={11} md={11}>
						<div style={{float: 'left'}}>
							{this.renderCheckbox({key: 'defaultBankAccount', label: 'Make this default'})}
						</div>
						<div style={{float: 'right'}}>
							<Button
								color="danger"
								type="button"
								onClick={(e) => this.closeForm()}
							>
								Cancel
							</Button>
							<Button
								color="success"
								type="submit"
							>
								{this.state.form.bankAccountId ? 'Edit' : 'Add'}
							</Button>
						</div>
					</GridItem>
				</GridContainer>
			</form>
		)

	}
	select(id){
		let selected = this.state.selected === id ? -1 : id
		this.setState({
			...this.state,
			selected: selected
		})
	}
	editFormItem(e){
		const {ib:{bankAccounts}, selected} = this.state
		const itemToEdit = bankAccounts.find((x) => x.bankAccountId === selected)

		this.setState({
			...this.state,
			form: itemToEdit,
			showForm: true
		})
	}
	deleteItem(id){
		let ib = this.state.ib
		ib.bankAccounts = ib.bankAccounts.filter((x) => x.bankAccountId !== id)
		let data = {...this.props.wizardData, ...ib}
    this.props.save(data)
      .then(e => {
				this.props.fetch(e.ibId)
					.then((res) => {
						this.setState({
							...state,
							ib:{
								bankAccounts: res.bankAccounts
							},
							showForm: false
						})

					})
        //this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})

	}
  render() {
		//const {classes} = this.props
		let {showForm, ib} = this.state
		
		return (
			<GridContainer justify="center">

				{!showForm && (
					<GridContainer justify="center">
					
						<GridItem xs={11} sm={11}>
							<div style={{float: 'right'}}>
								<span
									onClick={() => this.addNew()}
								>
									<Add
										style={{
											boxShadow: '0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)',
											backgroundColor: '#00acc1',
											color: 'white',
											border: 'transparent',
											height: '30px',
											width: '30px',
											borderRadius: '50%',
											cursor: 'pointer'
										}}
									/>
								</span>
							</div>
							
						</GridItem>
						<GridItem xs={11} sm={11} md={11}>
						
							<div style={{border:'1px solid #AAAAAA', marginTop: '20px'}}>
								<Table
									tableHeaderColor="primary"
									striped
									responsiveY
									tableHead={{
										checkbox: '',
										bankAccountId: '#',
										bankName: 'Bank Name',
										beneficiaryAccountName:"Beneficiary Account Name", 
										beneficiaryAddress:"Beneficiary Address",
										branchName:"Branch Name",
										beneficiaryIban:"Beneficiary IBAN",
										swiftCode:"SWIFT Code",
										// correspondentBankName: 'Correspondent Bank Name',
										// correspondentSwiftCode: 'Correspondent Swift Code',
										actions: ''
									}}
									tableData={ib.bankAccounts.sort((a, b) => a.bankAccountId - b.bankAccountId).map((e,i) => [
										<div style={{marginLeft: '10px'}}><Checkbox props={{
											onClick:()=>this.select(e.bankAccountId),
                      checked:this.state.selected===e.bankAccountId
										}} /></div>,
										e.bankAccountId,
										e.bankName,
										e.beneficiaryAccountName,
										e.beneficiaryAddress,
										e.branchName,
										e.beneficiaryIban,
										e.swiftCode,
										// e.correspondentBankName,
										// e.correspondentSwiftCode,
										<div>
											
											<span
												style={{
													cursor: 'pointer',
													visibility: this.state.selected === e.bankAccountId ? 'visible' : 'collapse'
												}}
												onClick={(e) => this.editFormItem(e)}
											>
												<Create />
											</span>

											<span
												style={{
													color: '#f44336',
													cursor: 'pointer',
													visibility: this.state.selected === e.bankAccountId ? 'visible' : 'collapse'
												}}
												onClick={(x) => this.deleteItem(e.bankAccountId)}
											>
												<Close />
											</span>
											
											
										</div>
									])}
								/>
							</div>
						</GridItem>
					</GridContainer>
				)}
				

				{showForm && (
					this.renderAddItemForm()
				)}

				<GridItem sm={11}>
					<div style={{float: 'left'}}>
						<Button
							// color="success"
							type="button"
							onClick={(e) => this.props.goToPreviousStep(ib)}
							style={{position:'absolute', bottom:'10px', left:'40px'}}
						>
							Previous
						</Button>
					</div>
					<div style={{float: 'right'}}>
						<Button
							color="success"
							type="button"
							onClick={(e) => this.props.goToNextStep(ib)}
							style={{position:'absolute', bottom:'10px', right:'40px'}}
						>
							Next
						</Button>
					</div>
				</GridItem>
			</GridContainer>
		)
  }
}
const state=(state)=>({
  ibs: state
})
const dispatch=(dispatch)=>({
  fetch:(id)=>dispatch(ibFetch(id)),
  save:(data)=>dispatch(ibSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
})
export default withStyles({...styles, ...regularFormsStyle})(connect(state,dispatch)(IbBankAccounts))



// WEBPACK FOOTER //
// ./src/views/Ibs/Wizard/IbBankAccounts.jsx